import React, { useState, useEffect } from "react";
import TableComponent from "../components/TableLayout";
import { useAxios } from "../hooks/useAxios";
import "react-toastify/dist/ReactToastify.css";
import { Typography } from "@mui/material";
import moment from "moment";

const Attendance = () => {
  const [header] = useState([
    {
      id: 1,
      label: "CBBF Staff Name",
      value: "field_worker_name",
    },
    {
      id: 2,
      label: "Place Name",
      value: "punch_place",
    },
    {
      id: 3,
      label: "Hospital Name",
      value: "hospital_name",
    },
    {
      id: 4,
      label: "Device ID",
      value: "device_id",
    },
    {
      id: 5,
      label: "Punch In Time",
      value: "punch_in",
    },
    {
      id: 6,
      label: "Punch Out Time",
      value: "punch_out",
    },
    {
      id: 7,
      label: "Total Hours",
      value: "hours",
    },
    {
      id: 8,
      label: "Total Hours",
      value: "hours",
    },
  ]);
  const { axios } = useAxios();
  const [attendanceList, setAttendanceList] = useState([]);
  const [length, setLength] = useState();
  let paginationInfo = {
    page: 1,
    count: 0,
    rowsPerPage: 10,
  };
  const [pageInfo, setPageInfo] = useState(paginationInfo);
  let dateFields = ["created_on"];
  const [searchValue, setSearchValue] = React.useState({
    fieldworker: "",
    hospital: "",
  });
  const [fieldWorkerDate, setFieldWorkerDate] = useState({
    startDate: "",
    endDate: "",
  });
  const [reset, setReset] = React.useState(false);

  useEffect(
    (values) => {
      AttendanceList();
    },
    [pageInfo.rowsPerPage, pageInfo.page, reset]
  );
  const handleSearchValue = (values, field) => {

    if (field == "hospital") {
      setSearchValue({
        ...searchValue,
        hospital: values,
      });
    } else {
      setSearchValue({
        ...searchValue,
        fieldworker: values,
      });
    }

  };
  const filterResponse = () => {
    setPageInfo((prevState) => ({ ...prevState, page: 1 }));
    if (pageInfo.page === 1) {
      AttendanceList();
    }
  };
  const AttendanceList = () => {
    let id = 5;
    let fromDate = fieldWorkerDate?.startDate
      ? moment(fieldWorkerDate?.startDate).format("YYYY-MM-DD")
      : "";
    let toDate = fieldWorkerDate?.endDate
      ? moment(fieldWorkerDate?.endDate).format("YYYY-MM-DD")
      : "";
    axios
      .post(
        `AttendanceList?limit=${pageInfo.rowsPerPage}&getcbbf=${id}&page=${pageInfo.page}&fromDate=${fromDate}&toDate=${toDate}&field_worker_name=${searchValue?.fieldworker}&hospital_name=${searchValue?.hospital}`
      )

      .then((data) => {
        setAttendanceList(data.data.result.list);
        setLength(data.data.result.length);
        setPageInfo((prevState) => ({
          ...prevState,
          count: data.data.result.length,
        }));
      })
      .catch(() => {
        setPageInfo(paginationInfo);
        setLength(0);
        setAttendanceList([]);
      });
  };
  const editData = (data) => { };
  const deleteDate = (data) => { };
  function deleteCancel(params) { }
  function deleteSubmit(params) { }
  const handleTablePage = (page) => {
    setPageInfo((prevState) => ({ ...prevState, page: page + 1 }));
  };
  const handleTableRowsPerPage = (rows) => {
    setPageInfo((prevState) => ({ ...prevState, rowsPerPage: rows }));
  };
  const handleDates = (value, field) => {
    if (field == "start") {

      var date = `${value.$y}-${value.$M + 1}-${value.$D}`;
      setFieldWorkerDate({
        ...fieldWorkerDate,
        startDate: date,
      });
    } else {

      var date = `${value.$y}-${value.$M + 1}-${value.$D}`;
      setFieldWorkerDate({
        ...fieldWorkerDate,
        endDate: date,
      });
    }
  };
  function clearValues() {
    setPageInfo(paginationInfo);
    setFieldWorkerDate({
      ...fieldWorkerDate,
      startDate: "",
      endDate: "",
    });
    setSearchValue({
      ...searchValue,
      hospital: "",
      fieldworker: "",
    });
    setReset(!reset);
  }
  return (
    <>
      <div>
        <Typography
          align="center"
          style={{ fontSize: "2rem", display: "flex" }}
        >
          CBBF - Fieldworker’s Attendance
        </Typography>
      </div>{" "}
      <TableComponent
        header={header}
        // addList={addStates}
        reset={reset}
        datewiseSearch={true}
        date={fieldWorkerDate}
        handleDate={(val, field) => handleDates(val, field)}
        datalist={attendanceList}
        datalength={length}
        editData={(id) => editData(id)}
        handleClearDate={() => clearValues()}
        handleFieldDate={() => filterResponse()}
        actions={[]}
        deleteData={(id) => deleteDate(id)}
        pageInfo={pageInfo}
        setPageInfo={setPageInfo}
        handleTablePage={handleTablePage}
        searchDataValue={(val, field) => handleSearchValue(val, field)}
        handleTableRowsPerPage={handleTableRowsPerPage}
        dateFields={dateFields}
      ></TableComponent>
    </>
  );
};

export default Attendance;
